<template>
  <div class="ring-diagram">
    <div class="card-item">
      <div
        class="item-title"
        :style="{
          color: indicatorStyle.titleColor,
          fontSize: indicatorStyle.titleFontsize + 'px'
        }"
      >
        {{ card.title }}
      </div>
      <div class="ring-diagram-content">
        <span>{{ indicatorStyle.before }}</span>
        <div
          class="item-content"
          @click="goRawData"
          :class="{ 'show-raw-data': showRawData && card.ids }"
          :style="{ color: indicatorStyle.numColor, fontSize: indicatorStyle.numFontsize + 'px' }"
        >
          {{ card.content }}
        </div>
        <span>{{ indicatorStyle.after }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ring-diagram",
  props: {
    card: Object,
    indicatorStyle: Object,
    yAxisList: Array,
    appId: String,
    sheetId: String,
    showRawData: Boolean,
    quotas: Array
  },
  methods: {
    goRawData() {
      if (this.showRawData && this.card.ids) {
        const quota = this.quotas.find(quota => quota.id === this.yAxisList[0]?.fieldId)
        const quotaFilters = quota.groupFilters || []
        localStorage.setItem(
          "chartDataFilter",
          JSON.stringify({ chartDataIds: this.card.ids, quotaFilters })
        )
        const { href } = this.$router.resolve({
          name: "worksheet",
          params: { appId: this.appId, sheetId: this.sheetId },
          query: { boardFlag: true }
        })
        window.open(href, "_blank")
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ring-diagram {
  height: 100%;
  width: 94%;
  .card-item {
    display: grid;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
    position: relative;
    text-align: center;
    .item-title {
      font-size: 14px;
    }
    .ring-diagram-content {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .item-content {
        margin: 15px 10px 0;
        font-size: 50px;
      }
      .show-raw-data {
        cursor: pointer;
      }
    }
  }
}
</style>
